// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IZ4V","newExpiryDate":"styles_newExpiryDate__Uhq7S","footer":"styles_footer__2zyq5"};